// Filter input with search icon / clear button

import './FilterInput.scss';

export default function FilterInput({
  value,
  onChange,
  placeholder = 'Search',
  className,
  small,
  disabled,
}) {
  return (
    <div
      className={
        'input filter-input' +
        (className ? ' ' + className : '') +
        (disabled ? ' disabled' : '')
      }
    >
      <input
        type='text'
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={small ? 'small' : ''}
      />
      <div className='search-controls'>
        {!value.trim() ? (
          <p
            className={'search-icon fa-search' + (small ? ' small' : '')}
            aria-hidden='true'
          />
        ) : (
          <button
            type='button'
            className={'search-btn' + (small ? ' small' : '')}
            onClick={() => onChange('')}
            aria-label='Clear search'
          >
            <p className='fa-cross' />
          </button>
        )}
      </div>
      <p className={'label' + (value ? ' visible' : '')}>{placeholder}</p>
    </div>
  );
}
